import source from "./menu-additions-2026-10-09.json";
const tr = (es, en, va) => ({ es, en, va });

export const MENU_ADDITIONS_UI = {
  pending: tr("Fichas de alérgenos pendientes de recibir. Consulta con el personal antes de pedir.", "Official allergen sheets are awaited. Please check with our staff before ordering.", "Fitxes d'al·lèrgens pendents de rebre. Consulta el personal abans de demanar."),
  caution: tr("La falta de iconos no significa ausencia de alérgenos o trazas.", "Missing icons do not mean that allergens or traces are absent.", "La falta d'icones no significa absència d'al·lèrgens o traces."),
  glass: tr("Copa", "Glass", "Copa"),
  kidsLabel: tr("La mesa de los pequeños", "The little ones' table", "La taula dels menuts"),
  kidsTitle: tr("Pequeños comensales. Grandes momentos.", "Little diners. Big moments.", "Menuts comensals. Grans moments."),
  kidsAsset: "/illustrations/ritual-kids-table.svg",
};

export const UPDATED_MENU_TABS = Object.fromEntries(source.tabs.map((tab) => [tab.key, {
  key: tab.key, label: tab.label, source: tab.source, hours: tab.hours,
  pendingAllergenSheets: true,
  sections: tab.sections.map((section) => ({ ...section, items: section.items.map((item) => ({
    ...item, allergenRecord: { id: item.id, status: "pending", confirmed: [] },
  })) })),
}]));